export default __webpack_public_path__ + "static/media/NED.398702d5.svg";